import type {
  ApiResponse,
  PaginatedResponse,
  SupportBroadcastResultDTO,
  SupportConversationDTO,
  SupportMessageDTO,
} from '@klaro7/shared-types';

import api from '@/lib/api';

export async function getMyThread(): Promise<SupportConversationDTO> {
  const res = await api.get<ApiResponse<SupportConversationDTO>>('/support/my');
  return res.data.data;
}

export async function listInbox(status?: string): Promise<SupportConversationDTO[]> {
  const res = await api.get<ApiResponse<SupportConversationDTO[]>>('/support/conversations', {
    params: status ? { status } : {},
  });
  return res.data.data;
}

export async function getMessages(
  conversationId: string
): Promise<PaginatedResponse<SupportMessageDTO>> {
  const res = await api.get<PaginatedResponse<SupportMessageDTO>>(
    `/support/conversations/${conversationId}/messages`,
    { params: { limit: 100 } }
  );
  return res.data;
}

export async function sendMessage(
  conversationId: string,
  content: string,
  files: File[] = []
): Promise<SupportMessageDTO> {
  const form = new FormData();
  form.append('conversationId', conversationId);
  form.append('content', content);
  files.forEach((f) => form.append('files', f));
  const res = await api.post<ApiResponse<SupportMessageDTO>>('/support/messages', form, {
    headers: { 'Content-Type': 'multipart/form-data' },
  });
  return res.data.data;
}

export interface BroadcastPayload {
  content: string;
  allProfessionals?: boolean;
  professionalIds?: string[];
}

export async function broadcastMessage(payload: BroadcastPayload): Promise<SupportBroadcastResultDTO> {
  const res = await api.post<ApiResponse<SupportBroadcastResultDTO>>('/support/messages/broadcast', payload);
  return res.data.data;
}

export async function markRead(conversationId: string): Promise<void> {
  await api.put(`/support/conversations/${conversationId}/read`);
}

export async function openThread(proId: string): Promise<SupportConversationDTO> {
  const res = await api.post<ApiResponse<SupportConversationDTO>>(
    `/support/conversations/${proId}/open`
  );
  return res.data.data;
}

export async function setStatus(
  conversationId: string,
  status: string,
  assignedAdminId?: string | null
): Promise<SupportConversationDTO> {
  const res = await api.put<ApiResponse<SupportConversationDTO>>(
    `/support/conversations/${conversationId}/status`,
    { status, assignedAdminId }
  );
  return res.data.data;
}

export async function assign(
  conversationId: string,
  assignedAdminId: string | null
): Promise<SupportConversationDTO> {
  const res = await api.put<ApiResponse<SupportConversationDTO>>(
    `/support/conversations/${conversationId}/assign`,
    { assignedAdminId }
  );
  return res.data.data;
}

export async function getUnreadCount(): Promise<number> {
  const res = await api.get<ApiResponse<{ count: number }>>('/support/unread-count');
  return res.data.data.count;
}
